module.exports = __webpack_public_path__ + "images/icon-link.c829b81e1241b90d7594.svg";